var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Label, MessageBanner, Modal, ModalFooter, Row, TextLink, } from "@folio/stripes/components";
import { useOkapiKy } from "@folio/stripes/core";
import { FormattedMessage, useIntl } from "react-intl";
import { useMutation } from "react-query";
import { RecekOnixItemPicker, RecekTextField } from "../inputs";
import { getStorageUploadError, uploadStorageFile, } from "../../api/storageService";
import { ErrorType } from "../../types/ErrorType";
import { finalizeResourceDraft, isLinkDetachedFromStorage, } from "../../utils/resourceDraft";
import { IMAGE_MODE_VALUE, IMAGE_UPLOAD_MAX_BYTES, IMAGE_UPLOAD_MIME_TYPES, isImageResourceType, PDF_UPLOAD_MAX_BYTES, PDF_UPLOAD_MIME_TYPES, requiresImageMode, resolveUploadKind, } from "../../utils/resourceImageRules";
import { formatFileSize } from "../../utils/formatFileSize";
import sharedCss from "./FormModal.module.css";
import css from "./ResourceFormModal.module.css";
var ERROR_MESSAGE_IDS = {
    required: "ui-br-agency.title.form.error.required",
    invalidLink: "ui-br-agency.title.validation.resourceLink.web",
    invalidImageMode: "ui-br-agency.title.validation.resourceMode.image",
    invalidImageLink: "ui-br-agency.title.validation.resourceLink.image",
    invalidPdfLink: "ui-br-agency.title.validation.resourceLink.pdf",
};
var DEFAULT_ADD_TITLE_ID = "ui-br-agency.title.resources.form.add.title";
/** What the upload accepts per kind — the limits mirror the backend. */
var UPLOAD_RULES = {
    image: {
        mimeTypes: IMAGE_UPLOAD_MIME_TYPES,
        maxBytes: IMAGE_UPLOAD_MAX_BYTES,
        labelId: "ui-br-agency.title.resource.upload.label",
        mimeErrorId: "ui-br-agency.title.resource.upload.error.mime",
        sizeErrorId: "ui-br-agency.title.resource.upload.error.size",
    },
    pdf: {
        mimeTypes: PDF_UPLOAD_MIME_TYPES,
        maxBytes: PDF_UPLOAD_MAX_BYTES,
        labelId: "ui-br-agency.title.resource.upload.label.pdf",
        mimeErrorId: "ui-br-agency.title.resource.upload.error.mime.pdf",
        sizeErrorId: "ui-br-agency.title.resource.upload.error.size.pdf",
    },
};
/** Antivirus rejections of an upload (issue #75957), translated in the UI. */
var UPLOAD_ERROR_MESSAGE_IDS = (_a = {},
    _a[ErrorType.STORAGE_UPLOAD_VIRUS_FOUND] = "ui-br-agency.title.resource.upload.error.virus",
    _a[ErrorType.STORAGE_ANTIVIRUS_UNAVAILABLE] = "ui-br-agency.title.resource.upload.error.antivirusUnavailable",
    _a);
export function ResourceFormModal(_a) {
    var _this = this;
    var _b, _c;
    var open = _a.open, isEditing = _a.isEditing, draft = _a.draft, onDraftChange = _a.onDraftChange, resourceTypeOptions = _a.resourceTypeOptions, resourceTypeLoading = _a.resourceTypeLoading, resourceTypeStatus = _a.resourceTypeStatus, resourceModeOptions = _a.resourceModeOptions, resourceModeLoading = _a.resourceModeLoading, resourceModeStatus = _a.resourceModeStatus, _d = _a.addTitleId, addTitleId = _d === void 0 ? DEFAULT_ADD_TITLE_ID : _d, onSave = _a.onSave, onClose = _a.onClose;
    var formatMessage = useIntl().formatMessage;
    var ky = useOkapiKy();
    var _e = useState(null), error = _e[0], setError = _e[1];
    var uploadedLinkRef = useRef(undefined);
    var fileInputRef = useRef(null);
    var draftRef = useRef(draft);
    draftRef.current = draft;
    useEffect(function () {
        if (open) {
            var d = draftRef.current;
            uploadedLinkRef.current = d.storageKey ? d.link : undefined;
            setError(null);
            return;
        }
        uploadedLinkRef.current = undefined;
        setError(null);
        if (fileInputRef.current)
            fileInputRef.current.value = "";
    }, [open]);
    // Image content types (ONIX list 158 codes 01–10) always use the Image mode
    // (list 159 code 03), and the mode picker is locked for them. Enforced as an
    // effect so it also covers a freshly seeded draft, an older resource opened
    // for editing and mode options that arrive after the modal opened.
    var imageModeOption = resourceModeOptions.find(function (option) { return option.value === IMAGE_MODE_VALUE; });
    var imageTypeSelected = isImageResourceType(draft.type);
    var needsImageMode = requiresImageMode(draft.type, draft.mode);
    useEffect(function () {
        if (open && needsImageMode && imageModeOption) {
            onDraftChange(function (prev) { return (__assign(__assign({}, prev), { mode: imageModeOption })); });
        }
    }, [open, needsImageMode, imageModeOption, onDraftChange]);
    var uploadKind = resolveUploadKind(draft.type, draft.mode);
    var uploadRules = uploadKind ? UPLOAD_RULES[uploadKind] : undefined;
    var uploadErrorMessageId = function (status, type) {
        var antivirusId = type ? UPLOAD_ERROR_MESSAGE_IDS[type] : undefined;
        if (antivirusId)
            return antivirusId;
        if (status === 413 && uploadRules)
            return uploadRules.sizeErrorId;
        if (status === 400 && uploadRules)
            return uploadRules.mimeErrorId;
        return "ui-br-agency.title.resource.upload.error.generic";
    };
    var _f = useMutation({
        mutationFn: function (file) { return uploadStorageFile(ky, file); },
        onSuccess: function (resp) {
            onDraftChange(function (prev) {
                var _a;
                return (__assign(__assign({}, prev), { storageKey: resp.storageKey, mimeType: resp.mimeType, fileSize: resp.fileSize, link: (_a = resp.publicUrl) !== null && _a !== void 0 ? _a : prev.link }));
            });
            uploadedLinkRef.current = resp.publicUrl;
            setError(null);
        },
        // Translate the backend's reason (antivirus, size, format) to Czech; its
        // own texts are English technical messages and are never shown raw.
        onError: function (e) { return __awaiter(_this, void 0, void 0, function () {
            var _a, status, type;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, getStorageUploadError(e)];
                    case 1:
                        _a = _b.sent(), status = _a.status, type = _a.type;
                        setError(formatMessage({ id: uploadErrorMessageId(status, type) }));
                        return [2 /*return*/];
                }
            });
        }); },
    }), doUpload = _f.mutate, uploading = _f.isLoading;
    var handleFilePick = function (e) {
        var _a;
        var file = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0];
        // Reset right away so that picking the same file again (after a rejection
        // or a failed upload) fires a change event again.
        e.target.value = "";
        if (!file || !uploadRules)
            return;
        setError(null);
        if (!uploadRules.mimeTypes.includes(file.type)) {
            setError(formatMessage({ id: uploadRules.mimeErrorId }));
            return;
        }
        if (file.size > uploadRules.maxBytes) {
            setError(formatMessage({ id: uploadRules.sizeErrorId }));
            return;
        }
        doUpload(file);
    };
    var linkChanged = isLinkDetachedFromStorage(draft, uploadedLinkRef.current);
    var handleSave = function () {
        var result = finalizeResourceDraft(draft, uploadedLinkRef.current);
        if (result.error) {
            setError(formatMessage({ id: ERROR_MESSAGE_IDS[result.error] }));
            return;
        }
        onSave(result.draft);
    };
    var hasUpload = uploadRules !== undefined;
    var previewVisible = draft.storageKey && draft.link && !linkChanged;
    var fileSizeLabel = draft.fileSize !== undefined ? formatFileSize(draft.fileSize) : undefined;
    var footer = (React.createElement(ModalFooter, null,
        React.createElement(Button, { buttonStyle: "primary", onClick: handleSave, disabled: uploading },
            React.createElement(FormattedMessage, { id: "ui-br-agency.button.save" })),
        React.createElement(Button, { buttonStyle: "default", onClick: onClose },
            React.createElement(FormattedMessage, { id: "ui-br-agency.button.cancel" }))));
    var modalLabel = isEditing
        ? formatMessage({ id: "ui-br-agency.title.resources.form.edit.title" })
        : formatMessage({ id: addTitleId });
    return (React.createElement(Modal, { open: open, onClose: onClose, label: modalLabel, footer: footer, size: "large", dismissible: true },
        error && (React.createElement(MessageBanner, { type: "error", className: sharedCss.errorBanner }, error)),
        React.createElement(Row, null,
            React.createElement(Col, { xs: hasUpload ? 6 : 4, className: css.cellSpacing },
                React.createElement(RecekOnixItemPicker, { labelId: "ui-br-agency.title.resource.type.label", dataOptions: resourceTypeOptions, value: draft.type, onChange: function (type) { return onDraftChange(function (prev) { return (__assign(__assign({}, prev), { type: type })); }); }, required: true, loading: resourceTypeLoading, codetableStatus: resourceTypeStatus })),
            React.createElement(Col, { xs: hasUpload ? 6 : 4, className: css.cellSpacing },
                React.createElement(RecekOnixItemPicker, { labelId: "ui-br-agency.title.resource.mode.label", dataOptions: resourceModeOptions, value: draft.mode, onChange: function (mode) { return onDraftChange(function (prev) { return (__assign(__assign({}, prev), { mode: mode })); }); }, required: true, disabled: imageTypeSelected, loading: resourceModeLoading, codetableStatus: resourceModeStatus })),
            React.createElement(Col, { xs: hasUpload ? 6 : 4, className: css.cellSpacing }, hasUpload ? (React.createElement(React.Fragment, null,
                React.createElement("div", { className: css.linkRow },
                    React.createElement("div", { className: css.linkInputWrap },
                        React.createElement(RecekTextField, { labelId: "ui-br-agency.title.resource.link.label", value: (_b = draft.link) !== null && _b !== void 0 ? _b : "", onChange: function (e) {
                                return onDraftChange(function (prev) { return (__assign(__assign({}, prev), { link: e.target.value })); });
                            }, required: true })),
                    React.createElement(Button, { buttonStyle: "default", onClick: function () {
                            return onDraftChange(function (prev) { return (__assign(__assign({}, prev), { link: "" })); });
                        }, disabled: !draft.link, "aria-label": formatMessage({
                            id: "ui-br-agency.title.resource.upload.clear",
                        }) }, "\u00D7")),
                linkChanged && (React.createElement(MessageBanner, { type: "warning" },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.title.resource.link.editWarning" }))))) : (React.createElement(RecekTextField, { labelId: "ui-br-agency.title.resource.link.label", value: (_c = draft.link) !== null && _c !== void 0 ? _c : "", onChange: function (e) {
                    return onDraftChange(function (prev) { return (__assign(__assign({}, prev), { link: e.target.value })); });
                }, required: true }))),
            uploadRules && (React.createElement(Col, { xs: 6, className: css.cellSpacing },
                React.createElement(Label, { htmlFor: "resource-file-upload" },
                    React.createElement(FormattedMessage, { id: uploadRules.labelId })),
                React.createElement("input", { id: "resource-file-upload", type: "file", accept: uploadRules.mimeTypes.join(","), onChange: handleFilePick, ref: fileInputRef, disabled: uploading, className: css.hiddenFileInput }),
                React.createElement(Button, { buttonStyle: "default", onClick: function () { var _a; return (_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click(); }, disabled: uploading },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.title.resource.upload.chooseFile" })),
                uploading && (React.createElement("div", { className: css.uploadStatus },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.title.resource.upload.uploading" }))),
                draft.storageKey && !uploading && (React.createElement("div", { className: css.uploadStatus },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.title.resource.upload.success" }),
                    fileSizeLabel !== undefined && " \u00B7 ".concat(fileSizeLabel))),
                previewVisible && uploadKind === "pdf" && (React.createElement("div", { className: css.uploadStatus },
                    React.createElement(TextLink, { href: draft.link, target: "_blank", rel: "noopener noreferrer" },
                        React.createElement(FormattedMessage, { id: "ui-br-agency.title.resource.upload.openFile" })))),
                previewVisible && uploadKind === "image" && (React.createElement("img", { src: draft.link, alt: formatMessage({
                        id: "ui-br-agency.title.resource.upload.previewAlt",
                    }), className: css.preview })))))));
}
